import { map as _map } from 'lodash-es';
import { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import SupervisedUserCircle from '@mui/icons-material/SupervisedUserCircle';
import SelectField from '../forms/select-field';
import { eventAgeRestrictions } from '../../utils/events';

const useStyles = makeStyles()((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormAgeRestriction = (props) => {
  const { classes } = useStyles();

  const options = useMemo(() => (
    _map(eventAgeRestrictions, ({ name, description }, value) => ({
      label: `${name} (${description})`,
      value,
    }))
  ), []);

  return (
    <SelectField
      name="ageRestriction"
      label={(
        <span className={classes.label}>
          <SupervisedUserCircle className={classes.icon} />
          Age restriction
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormAgeRestriction;
